module.exports = __webpack_public_path__ + "static/media/0_2019_09_11.4f59b2ce.jpg";